import { createContext } from "react";

import { TooltipManagerContextValue } from "@/hooks/onboardingTooltipConstants";

export const TooltipManagerContext = createContext<TooltipManagerContextValue | null>(null);
